<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-layout class="px-3 py-2" row wrap>
      <v-flex xs12 lg12>
        <span class="body-2">{{ $t('message.bizgainOnboarding.selectCurrency') }}</span>
      </v-flex>
      <v-flex lg12 xs12>
        <v-select
          v-model="selectedRegion"
          :items="validRegions"
          return-object
        >
          <template v-slot:selection="data">
            <v-layout row>
              <v-flex lg2 xs3>
                <v-img :src="data.item.flagSource" contain height="20" />
              </v-flex>
              <v-flex lg10 xs9>
                <p class="pa-0 ma-0">
                  {{ data.item.country }}({{ data.item.currencyCode }})
                </p>
              </v-flex>
            </v-layout>
          </template>
          <template v-slot:item="data">
            <v-layout row class="pa-0 ma-0">
              <v-flex lg2 xs3>
                <v-img :src="data.item.flagSource" contain height="20" />
              </v-flex>
              <v-flex lg10 xs9>
                <p class="pa-0 ma-0">
                  {{ data.item.country }}({{ data.item.currencyCode }})
                </p>
              </v-flex>
            </v-layout>
          </template>
        </v-select>
      </v-flex>
      <v-flex xs12 lg12>
        <v-btn class="next-btn-color" @click="handleSubmit">
          {{ $t('message.bizgainOnboarding.continue') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-dialog>
</template>
<script>
import {
  VDialog,
  VSelect,
  VLayout,
  VFlex,
  VBtn,
  VImg
} from 'vuetify/lib';
import AppConfig from 'Constants/AppConfig';
import { mapActions, mapGetters } from 'vuex';
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VDialog,
    VSelect,
    VLayout,
    VFlex,
    VBtn,
    VImg
  },
  data(){
    return {
      selectedRegion: {},
      AppConfig
    }
  },
  computed: {
    ...mapGetters(['portal', 'validRegions', 'regionConfig'])
  },
  created(){
    this.selectedRegion = this.regionConfig;
  },
  methods: {
    ...mapActions(['setRegion']),
    handleSubmit(){
      this.setRegion(this.selectedRegion.region);
      this.$emit('update:dialog', false);
      this.$emit('regionSelected');
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep{
.v-dialog {
  background-color: white;
}
}

</style>